module.exports = __webpack_public_path__ + "img/Deaminasevariants_R.c01b2e24.svg";